import FormattedMessage from 'I18n/components/FormattedMessage';
import UIList from 'UIComponents/list/UIList';
import UIScrollContainer from 'UIComponents/scroll/UIScrollContainer';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { useQuickFilterGroupNameAndDesc } from '../hooks/useQuickFilterGroupNameAndDesc';
import DataSourcePropertyLabel from './DataSourcePropertyLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GroupedPinnedPropertyFilterTooltip = ({
  quickFilterGroup,
  disabled,
  children
}) => {
  const {
    description
  } = useQuickFilterGroupNameAndDesc(quickFilterGroup);
  const {
    properties
  } = quickFilterGroup;
  const isQuickFilterButtonDisabled = quickFilterGroup.properties.length === 0;
  if (isQuickFilterButtonDisabled) {
    return /*#__PURE__*/_jsx(UITooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "quickFilter.groupedQuickFilter.validations.allPropertiesInvalid"
      }),
      children: children
    });
  }
  return /*#__PURE__*/_jsx(UITooltip, {
    disabled: disabled,
    use: "longform",
    placement: "top",
    "data-test-id": "grouped-pinned-property-tooltip",
    title: /*#__PURE__*/_jsxs(UIScrollContainer, {
      maxHeight: 150,
      children: [description && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          children: description
        }), /*#__PURE__*/_jsx("br", {})]
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'quickFilter.groupedQuickFilter.popover.tooltip.propertiesListLabel'
      }), /*#__PURE__*/_jsx(UIList, {
        className: "m-y-2 p-left-4",
        styled: true,
        children: properties.map((propertyObj, index) => {
          const {
            property,
            dataSource
          } = propertyObj;
          return /*#__PURE__*/_jsx(DataSourcePropertyLabel, {
            dataSource: dataSource,
            property: property
          }, index);
        })
      })]
    }),
    children: children
  });
};
export default GroupedPinnedPropertyFilterTooltip;